module.exports = __webpack_public_path__ + "img/20200320105142391.33d3a46e.png";